<div class="community-all">
  <form class="prefix-search {{ capacitor.getPlatform() === 'ios' ? 'capacitor' : '' }}">
    <mat-form-field
      appearance="outline"
      class="sharry-small-form-field no-error"
      (click)="auto.isOpen ? null : (auto.showPanel = true)">
      <input
        #autoCompleteInput
        matInput
        [matAutocomplete]="auto"
        [matAutocompletePosition]="'below'"
        [formControl]="search"
        [placeholder]="'community-all.placeholder' | i18next"
        (keydown.enter)="onOptionClick(null, autoCompleteInput)"
        (focusin)="mobileSuggestion = true"
        (focusout)="mobileSuggestion = false" />
      <mat-autocomplete
        #auto="matAutocomplete"
        class="prefix-search__autocomplete is-not-mobile"
        (optionSelected)="onOptionClick($event, autoCompleteInput)">
        <div
          class="prefix-search__autocomplete__content community-all__autocomplete__content  {{
            (usingCapacitor ?? capacitor.getPlatform() === 'ios') ? 'capacitor-height' : ''
          }}">
          @if (!search?.value?.length && hashtagsOptions$ | async; as hashtagOptions) {
            <div class="is-mobile">
              <p class="community-all--trending semibold">{{ 'community.hastags' | i18next }}</p>
              @for (option of hashtagOptions; track option) {
                <mat-option
                  class="prefix-search__result community-all__prefix-search__result"
                  [value]="option">
                  <sharry-icon
                    name="hash"
                    type="phosphor"
                    svgClass="svg-icon"></sharry-icon>
                  <div>
                    <p
                      sharryEllipsisTooltip
                      class="medium"
                      [matTooltip]="option.name">
                      {{ option.name }}
                    </p>
                  </div>
                </mat-option>
              }
            </div>
            @if (featuredHashtagsOptions$ | async; as featuredHashtagOptions) {
              <p class="community-all--trending semibold">{{ 'community.featuredHastags' | i18next }}</p>
              @for (option of featuredHashtagOptions; track option) {
                <mat-option
                  class="prefix-search__result community-all__prefix-search__result"
                  [value]="option">
                  <sharry-icon
                    name="hash"
                    type="phosphor"
                    svgClass="svg-icon"></sharry-icon>
                  <div>
                    <p
                      sharryEllipsisTooltip
                      class="medium"
                      [matTooltip]="option.name">
                      {{ option.name }}
                    </p>
                  </div>
                </mat-option>
              }
              @if (!featuredHashtagOptions.length) {
                <mat-option [disabled]="true">
                  <p class="medium">{{ 'community-all.no-featured' | i18next }}</p>
                </mat-option>
              }
            }
          }
          @if (search?.value?.length && autocompleteOptions$ | async; as autocompleteOptions) {
            @for (option of autocompleteOptions; track option) {
              <mat-option
                class="prefix-search__result community-all__prefix-search__result"
                [value]="option">
                @if (option.__typename === 'Hashtag') {
                  <sharry-icon
                    name="hash"
                    type="phosphor"
                    svgClass="svg-icon"></sharry-icon>
                }
                <div>
                  <p
                    sharryEllipsisTooltip
                    class="medium"
                    [matTooltip]="
                      option.__typename === 'Hashtag'
                        ? option.name
                        : option.__typename === 'Place'
                          ? $any(option).placeName.split(',')[0]
                          : (option | userName)
                    ">
                    {{
                      option.__typename === 'Hashtag'
                        ? option.name
                        : option.__typename === 'Place'
                          ? $any(option).placeName.split(',')[0]
                          : (option | userName)
                    }}
                  </p>
                </div>
              </mat-option>
            }
            @if (!autocompleteOptions.length && !!search.value?.length) {
              <mat-option [disabled]="true">
                <p class="medium">{{ 'community-all.no-suggestion' | i18next }}{{ search.value.replace('#', '') }}</p>
              </mat-option>
            }
          }
        </div>
      </mat-autocomplete>
      <sharry-icon
        matPrefix
        registryName="magnifying-glass"
        svgClass="svg-icon"></sharry-icon>
      @if (!!search?.value?.length) {
        <sharry-icon
          matSuffix
          name="x-circle-fill"
          svgClass="svg-icon touchable"
          (click)="search.setValue(''); onReset()"></sharry-icon>
      }
    </mat-form-field>
    @if (isSeek) {
      <button
        mat-stroked-button
        color="secondary"
        class="sharry-small rounded"
        style="margin-top: 1rem"
        (click)="onSeekDelete()">
        {{ 'community-all.search' | i18next }}
        <sharry-icon
          matSuffix
          name="x-circle-fill"
          svgClass="svg-icon"></sharry-icon>
      </button>
    }
  </form>
  @if (mobileSuggestion) {
    <div class="is-mobile community-all__mobile-suggestion">
      <div
        class="prefix-search__autocomplete__content community-all__autocomplete__content  {{
          usingCapacitor ? 'capacitor-height' : ''
        }}">
        @if (!search?.value?.length && hashtagsOptions$ | async; as hashtagOptions) {
          <div class="is-mobile">
            <p class="community-all--trending semibold">{{ 'community.hastags' | i18next }}</p>
            @for (option of hashtagOptions; track option) {
              <mat-option
                class="prefix-search__result community-all__prefix-search__result"
                [value]="option"
                (click)="onOptionMobileClick(option, autoCompleteInput)">
                <sharry-icon
                  name="hash"
                  type="phosphor"
                  svgClass="svg-icon"></sharry-icon>
                <div>
                  <p
                    sharryEllipsisTooltip
                    class="medium"
                    [matTooltip]="option.name">
                    {{ option.name }}
                  </p>
                </div>
              </mat-option>
            }
          </div>
          @if (featuredHashtagsOptions$ | async; as featuredHashtagOptions) {
            <p class="community-all--trending semibold">{{ 'community.featuredHastags' | i18next }}</p>
            @for (option of featuredHashtagOptions; track option) {
              <mat-option
                class="prefix-search__result community-all__prefix-search__result"
                [value]="option"
                (click)="onOptionMobileClick(option, autoCompleteInput)">
                <sharry-icon
                  name="hash"
                  type="phosphor"
                  svgClass="svg-icon"></sharry-icon>
                <div>
                  <p
                    sharryEllipsisTooltip
                    class="medium"
                    [matTooltip]="option.name">
                    {{ option.name }}
                  </p>
                </div>
              </mat-option>
            }
            @if (!featuredHashtagOptions.length) {
              <mat-option [disabled]="true">
                <p class="medium">{{ 'community-all.no-featured' | i18next }}</p>
              </mat-option>
            }
          }
        }
        @if (search?.value?.length && autocompleteOptions$ | async; as autocompleteOptions) {
          @for (option of autocompleteOptions; track option) {
            <mat-option
              class="prefix-search__result community-all__prefix-search__result"
              [value]="option"
              (click)="onOptionMobileClick(option, autoCompleteInput)">
              @if (option.__typename === 'Hashtag') {
                <sharry-icon
                  name="hash"
                  type="phosphor"
                  svgClass="svg-icon"></sharry-icon>
              }
              <div>
                <p
                  sharryEllipsisTooltip
                  class="medium"
                  [matTooltip]="
                    option.__typename === 'Hashtag'
                      ? option.name
                      : option.__typename === 'Place'
                        ? $any(option).placeName.split(',')[0]
                        : (option | userName)
                  ">
                  {{
                    option.__typename === 'Hashtag'
                      ? option.name
                      : option.__typename === 'Place'
                        ? $any(option).placeName.split(',')[0]
                        : (option | userName)
                  }}
                </p>
              </div>
            </mat-option>
          }
          @if (!autocompleteOptions.length && !!search.value?.length) {
            <mat-option [disabled]="true">
              <p class="medium">{{ 'community-all.no-suggestion' | i18next }}{{ search.value.replace('#', '') }}</p>
            </mat-option>
          }
        }
      </div>
      <div class="divider"></div>
    </div>
  }

  @for (post of posts$ | async; track post.id) {
    <sharry-post
      #listItem
      [post]="post"
      [id]="'post-' + post.id"
      [layout]="'multiple'"
      (delete)="onDelete()"
      (block)="onBlock($event)"></sharry-post>
  } @empty {
    @if (isLoadingPosts) {
      <sharry-loading></sharry-loading>
      <div class="community-all__space"></div>
    } @else {
      <div class="community-all__empty">
        <p>
          {{ 'community-all.empty' | i18next }} <strong>{{ search?.value }} </strong>
        </p>
      </div>
    }
  }
  @if (postSubject.value.length < total) {
    <sharry-loading></sharry-loading>
  }
</div>

<button
  mat-flat-button
  color="primary"
  class="sharry-medium rounded floating hidden"
  (click)="onFloatingClick()">
  {{ 'community-all.new-posts' | i18next }}
  <sharry-icon
    matSuffix
    name="arrow-up"
    type="phosphor"></sharry-icon>
</button>
